import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import "../styles/AdminLayout.css";

const AdminLayout = ({ handleAdminLogout }) => {
  return (
    <div className="admin-layout">
      <Sidebar handleAdminLogout={handleAdminLogout} />
      <div className="admin-content">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;
